import React from 'react';
import {useIntl} from 'react-intl';

export const Disclaimer = () => {
  const intl = useIntl();
  return (
    <div className='bg-grey-bright px-4 py-2'>
      <p data-testid='disclaimer-text' className='text-sm text-grey'>
        <span className='font-semibold'>{intl.formatMessage({id: 'blogPost.disclaimer.label'})}</span> {intl.formatMessage({id: 'blogPost.disclaimer.text'})}
      </p>
    </div>
  );
};
